import { render } from "./articlePage.vue?vue&type=template&id=6a9a898d&scoped=true"
import script from "./articlePage.vue?vue&type=script&lang=js"
export * from "./articlePage.vue?vue&type=script&lang=js"

import "./articlePage.vue?vue&type=style&index=0&id=6a9a898d&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9a898d"]])

export default __exports__